/* Delivery-date gate (strict) + critical-window notice + any-date selection */
(function () {
  var KEY = 'Delivery Date';
  var RUSH_KEY = 'Rush Order Notice';
  var RUSH_DAYS = 6;
  var RUSH_TEXT = 'Critical window: orders for delivery in fewer than 6 days may not be possible to accommodate. Your request is not guaranteed. We will contact you to confirm whether we can fulfil this order.';
  var busy = false;
  var lastVal = null;
  var isCart = /^\/cart\/?$/.test(window.location.pathname);

  function sameDay(a, b) {
    return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }

  /* The date-picker app enforces a minimum lead time (currently 7 days). Allow any date from today onward. */
  function ensureAnyDate() {
    var $ = window.jQuery;
    if (!$) return;
    document.querySelectorAll('.sbt_datepicker_field').forEach(function (el) {
      var $el = $(el);
      var dp = $el.data('datepicker');
      if (!dp || !dp.options) return;
      var today = new Date();
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      if (!sameDay(dp.options.startDate, today)) {
        try { $el.datepicker('setStartDate', today); } catch (e) {}
      }
    });
  }

  function pickerInput() {
    return document.querySelector('.sbt-delivery-date--cart .sbt_datepicker_field') || document.querySelector('.sbt_datepicker_field');
  }

  function parseDate(s) {
    var m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(String(s).trim());
    if (m) return new Date(+m[3], +m[1] - 1, +m[2]);
    var d = new Date(s);
    return isNaN(d) ? null : new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }
  function daysAway(s) {
    var d = parseDate(s);
    if (!d) return null;
    var t = new Date();
    t = new Date(t.getFullYear(), t.getMonth(), t.getDate());
    return Math.round((d - t) / 864e5);
  }
  function hasValidDate() {
    var i = pickerInput();
    if (!i || !i.value || !i.value.trim()) return false;
    var n = daysAway(i.value);
    return n !== null && n >= 0;
  }

  function showMsg(text) {
    var host = document.querySelector('.sbt-delivery-date--cart') || document.querySelector('.sbt_delivery_date_wrapper_div') || document.querySelector('.cart__footer') || document.querySelector('cart-items');
    if (!host) { window.alert(text); return; }
    var m = document.getElementById('dd-required-msg');
    if (!m) {
      m = document.createElement('p');
      m.id = 'dd-required-msg';
      m.setAttribute('role', 'alert');
      m.style.cssText = 'color:#b00020;font-weight:600;margin:8px 0;';
      host.appendChild(m);
    }
    m.textContent = text;
    host.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var inp = pickerInput();
    if (inp && inp.focus) inp.focus();
  }

  function gate(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    if (isCart) {
      if (!pickerInput()) { showMsg('The delivery date selector is still loading. Please wait a moment, select a delivery date, then continue.'); return; }
      if (!hasValidDate()) { showMsg('Delivery date is required. Please select a delivery date to continue.'); return; }
    }
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        busy = false;
        if (!c.item_count) return;
        var v = c.attributes && c.attributes[KEY];
        var ok = v && String(v).trim() && (!isCart || (pickerInput() && pickerInput().value.trim() === String(v).trim()));
        if (ok) {
          window.location.href = '/checkout';
        } else if (isCart) {
          showMsg('Delivery date is required. Please select a delivery date to continue.');
        } else {
          window.alert('Please select a delivery date on the cart page before checking out.');
          window.location.href = '/cart';
        }
      })
      .catch(function () { busy = false; if (isCart) showMsg('Could not verify the delivery date. Please try again.'); });
  }

  function syncButtons() {
    if (!isCart) return;
    var ok = hasValidDate();
    document.querySelectorAll('#checkout, .cart__checkout-button, [name="checkout"]').forEach(function (b) {
      b.classList.toggle('dd-ok', ok);
      if (!ok) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
  }

  function syncNotice() {
    ensureAnyDate();
    syncButtons();
    var inputs = document.querySelectorAll('.sbt_datepicker_field');
    if (!inputs.length) return;
    var val = inputs[0].value || '';
    if (val === lastVal) return;
    lastVal = val;
    var n = val ? daysAway(val) : null;
    var rush = n !== null && n < RUSH_DAYS;
    inputs.forEach(function (inp) {
      var wrap = inp.closest('.sbt_delivery_date_wrapper_div') || inp.parentNode;
      var note = wrap.querySelector('.dd-rush-notice');
      if (rush) {
        if (!note) {
          note = document.createElement('div');
          note.className = 'dd-rush-notice';
          note.setAttribute('role', 'alert');
          note.style.cssText = 'margin:10px 0;padding:10px 12px;border-left:4px solid #b26a00;background:#fff4e0;color:#5a3600;font-size:14px;line-height:1.4;';
          wrap.appendChild(note);
        }
        note.textContent = RUSH_TEXT;
      } else if (note) {
        note.remove();
      }
      var err = document.getElementById('dd-required-msg');
      if (err && val) err.remove();
    });
    var attrs = {};
    attrs[RUSH_KEY] = rush ? RUSH_TEXT : '';
    fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[name="checkout"], a[href*="/checkout"]')) gate(e);
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var sub = e.submitter;
    var isCheckout = (sub && sub.name === 'checkout') || (f.getAttribute('action') || '').indexOf('/checkout') > -1 || (isCart && f.id === 'cart');
    if (isCheckout) gate(e);
  }, true);

  syncButtons();
  setInterval(syncNotice, 300);
})();
